var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMangoHabanero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / Flavor / MangoHabanero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "mangoH-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.295198,33.5474132 C17.7027584,33.5474132 16.2768778,28.7213263 16.2768778,28.7213263 C17.8502232,30.908915 20.6001909,30.793575 20.6001909,30.793575 C20.6001909,30.793575 15.1145762,28.1891369 15.1145762,23.3649852 C15.1145762,21.5892143 16.2997136,20.9219456 16.2997136,20.9219456 C16.2997136,20.9219456 15.9610476,21.115856 15.9610476,22.2766095 C15.9610476,25.6388853 21.765589,27.6615921 21.765589,27.6615921 C21.765589,27.6615921 19.8079061,26.2194556 19.8079061,24.5083215 C19.8079061,23.1230809 20.2185628,22.7673849 20.2185628,21.115469 C20.2185628,20.2515804 19.765718,19.5436718 19.765718,19.5436718 C19.765718,19.5436718 23.4086028,20.76016 23.9326642,23.1834602 C24.4118282,25.396981 23.3590608,27.1580441 23.3590608,27.1580441 C24.4276971,26.7032641 24.6533454,23.8035092 24.6533454,23.8035092 C27.6819868,24.5005806 29.0722591,33.5474132 23.295198,33.5474132 M17.3791872,14.198168 C17.3791872,14.198168 18.9382118,15.0690234 19.1808902,16.2781577 C19.8063579,19.3938847 18.1753425,21.3759515 18.1753425,21.3759515 C18.1753425,21.3759515 17.1465721,20.7470004 17.1465721,19.7596439 C17.1465721,18.0976648 18.1358638,17.8480196 18.1358638,16.1616566 C18.1358638,14.8569217 17.3791872,14.198168 17.3791872,14.198168 M21.0654212,12.8500839 C21.0654212,12.8500839 26.1694078,8.98619533 26.1694078,5 C26.1694078,5 17.5622604,5.11727519 17.5622604,12.743646 L14.5084608,8.46406915 L12.8778325,9.60276093 L15.8971849,13.3195717 C15.8971849,13.3195717 11.08,14.8983357 11.08,21.660818 C11.08,26.5383821 15.6707625,35 21.8608025,35 C28.5400697,35 28.9135699,31.3954328 28.9135699,29.6541091 C28.9135699,26.8484067 26.5374894,24.9131725 26.5374894,18.0968907 C26.5374894,14.9989679 21.0654212,12.8500839 21.0654212,12.8500839",
    id: "mangoH-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mangoH-icon-/-Flavor-/-MangoHabanero",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mangoH-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "mangoH-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mangoH-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "mangoH-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mangoH-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mangoH-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "mangoH-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#mangoH-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mangoH-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#mangoH-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mangoH-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mangoH-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "mangoH-Fill-1",
    fill: "#231F20",
    xlinkHref: "#mangoH-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mangoH-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#mangoH-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMangoHabanero);
export default __webpack_public_path__ + "static/media/MangoHabanero.fe3cbc69ccc6dc0547a1502e2f123301.svg";
export { ForwardRef as ReactComponent };